// Handle HTTP errors since fetch won't.
export default function handleErrors(response) {
  if (!response.ok) {
    throw {
      status: response.status,
    };
  }
  return response;
}
